<template>
    <div class="gift">
        <div class="bannerList" :style="{backgroundImage:`url('static/gift/banner.jpg')`}">
        </div>
        <div class="plan full-width">
            <div class="container">
                <h2>商务礼赠方案及流程</h2>
                <img class="plan-img" src="static/gift/VIP.png" alt="">
                <img class="plan-img" src="static/gift/jifenka.png" alt="">
                <img class="plan-img" src="static/gift/shangpin.png" alt="">
            </div>
        </div>
        <div class="goodness full-width" v-bind:style="{backgroundImage:`url('static/gift/goddnessteam.png')`}">
            <div class="container">
                <h2>项目优势</h2>
                <ul>
                    <li class="cursor good">
                        <p>根据客户预算</p>
                        <p>提供多样化礼赠方案</p>
                    </li>
                    <li class="cursor good">
                        <p>提供定制服务</p>
                        <p>彰显企业人文关怀</p>
                    </li>
                    <li class="cursor good">
                        <p>商品品类丰富</p>
                        <p>满足各类型礼赠需求</p>
                    </li>
                    <li class="cursor good">
                        <p>管理方式便捷</p>
                        <p>电商化采购，省心省力</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="erannde full-width">
            <div class="container">
                <h2>信赖，源自于他们的选择</h2>
                <div class=" clearfix">
                    <div class="erannde-item fl">
                        <img class="front" src="static/gift/yiqi1.png" alt="">
                        <img class="behind" src="static/gift/yiqi2.png" alt="">
                    </div>
                    <div class="erannde-item fl">
                        <img class="front" src="static/gift/chinabank.png" alt="">
                        <img class="front" src="static/gift/chinabank2.png" alt="">
                    </div>
                    <div class="erannde-item fl">
                        <img class="front" src="static/gift/BCN.png" alt="">
                        <img class="front" src="static/gift/BCN2.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "gift",
        metaInfo: {
            title: '福分通-商务礼赠', // set a title
            meta: [{                 // set meta
                name: '福分通',
                content: '专注企业员工福利'
            }]
        },
    }
</script>

<style scoped lang="stylus">
    .bannerList
        position absolute
        top 0
        z-index -1
        width 100%
        min-width 1200px
        height 640px
        display block
        overflow hidden
        text-align center
        background-size cover
        background-position center

    .plan
        text-align center
        h2
            display inline-block
            margin 100px auto 80px
            font-size 36px
            font-weight bold
            color black
        img.plan-img
            margin-bottom 50px

    .goodness
        height 500px
        text-align center
        background-position center
        background-size cover
        h2
            margin 50px auto
            display inline-block
            font-size 36px
            font-weight bold
            color white
        ul
            display block
            position absolute
            width 1180px
            top 360px
            li
                display inline-block
                width 25%
                p
                    font-size 16px
                    color white
                    font-weight bold
                    line-height 28px

    .erannde
        text-align center
        padding-bottom 100px
        background-color #f2f2f2
        h2
            margin 50px auto
            display inline-block
            font-size 36px
            font-weight bold
            color #000000
        &-item
            width 380px
            height 240px
            margin-right 20px
            overflow hidden
            &:last-child
                margin-right 0
            img
                transition 0.5s ease-in-out
            &:hover img
                transform translateY(-100%)

    .cursor.good:hover p
        color #0239f5

</style>